import { useState, useContext, useRef, useEffect } from 'react';
import { Link, Redirect, Route, useHistory, useLocation } from 'react-router-dom';
import {
	IonBadge, IonButton, IonButtons, IonCard, IonCardContent, IonCardSubtitle, IonCol, IonTabs, IonRouterOutlet, IonTabBar, IonTabButton,
	IonContent, IonGrid, IonHeader, IonIcon, IonPage, IonRow, IonTitle, IonToolbar, IonSpinner,
	IonItem, IonSearchbar, IonList, IonFabButton, IonFab, IonLabel, IonRefresher, IonRefresherContent,
	IonText, IonNote, IonInput,
	IonProgressBar
} from '@ionic/react';

import {
	IonReactRouter
} from '@ionic/react-router';
import styles from "./Home.module.css";
import {
	cartOutline, heartOutline, bagCheck, search, bookmarkOutline,
	refreshOutline, locationOutline, globeOutline,
	text,
} from 'ionicons/icons';

import { Preferences } from '@capacitor/preferences';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Keyboard, Pagination, Scrollbar, Zoom, Navigation } from 'swiper/modules';

import { FeaturedStore } from '../data/FeaturedStore';

import { ProductStore } from '../data/ProductStore';
import { FavouritesStore } from '../data/FavouritesStore';
import { CartStore } from '../data/CartStore';
import { CategoryStore } from '../data/CategoryStore';
import FavouriteProducts from './FavouriteProducts';
import CartProducts from './CartProducts';
import ProductCard from "../components/ProductCard";

import { fetchFeatured } from '../data/fetcher';

import AuthContext from '../UserContext';
import Contact from '../components/Contact';
import { set } from 'date-fns';
import { saveScrollBeforeNavigation } from '../utils/globalScrollManager';
import Product from './Product';
import { LazyImage } from '../components/LazyImage';

const Home = () => {

	const history = useHistory();
	const location = useLocation();

	const { authValues } = useContext(AuthContext);

	const products = ProductStore.useState(s => s.products);
	const favourites = FavouritesStore.useState(s => s.product_ids);
	const shopCart = CartStore.useState(s => s.product_ids);

	const cartRef = useRef();
	const searchInputRef = useRef();

	const categoryHasLoaded = CategoryStore.useState(s => s.hasLoaded);
	const productHasLoaded = ProductStore.useState(s => s.hasLoaded);

	const featuredProducts = FeaturedStore.useState(s => s.products);
	const featuredHasLoaded = FeaturedStore.useState(s => s.hasLoaded);
	const featuredPagination = FeaturedStore.useState(s => s.pagination);
	//LOAD MORE FEATURED PRODUCTS
	const [page, setPage] = useState(featuredPagination.current_page);
	const [loading, setLoading] = useState(false);
	const [hasMore, setHasMore] = useState(false);

	//RECENT SEARCHES
	const [recentSearches, setRecentSearches] = useState([]);
	const [showRecentSearches, setShowRecentSearches] = useState(false);

	const suggestProducts = ProductStore.useState(s => s.suggestProducts);

	useEffect(() => {
		const loadRecentSearches = async () => {
			const { value } = await Preferences.get({ key: 'recentSearches' });
			if (value) {
				setRecentSearches(JSON.parse(value));
			}
		};

		loadRecentSearches();
	}, []);

	useEffect(() => {

		if ((featuredPagination.current_page < featuredPagination.last_page))
			setHasMore(true);
		else
			setHasMore(false);

		setPage(featuredPagination.current_page);

	}, [featuredPagination.current_page]);

	// Function to fetch next set of products
	const fetchMoreProducts = async () => {
		setLoading(true);
		const response = await fetchFeatured(page + 1); // Your API call to fetch products, passing the current page
		setLoading(false);
	};

	// Load More button click handler
	const handleLoadMore = () => {
		if (!loading) {
			fetchMoreProducts();
		}
	};
	//END FEATURED PRODUCTS

	let [searchResults, setSearchResults] = useState([]);

	if (!productHasLoaded || !featuredHasLoaded || !categoryHasLoaded){
		return (
			<div className="logo-loader-container"> 
                <img 
                    src="/assets/icon/logo-sm.png" 
                    alt="Loading" 
                    className="logo-loader-image" 
                /> 
            </div>
		);
	}
		

	const handleSearchInput = (ev) => {

		setSearchResults([]);

		let query = '';
		const target = ev.target;
		if (target) query = target.value.toLowerCase();

		if (query.length < 3) return;
		Object.entries(products).filter(([idx, category]) => {
			category.products.filter((prod) => {
				if (prod.description.toLowerCase().indexOf(query) > -1 || prod.name.toLowerCase().indexOf(query) > -1) {
					setSearchResults(prev => [...prev, prod.name]);
				}
			});
		});

	};

	const searchListClick = async (ev, data = null, place = null, price_min = null, price_max = null) => {

		if (data === null)
			data = searchInputRef.current.value;

		let searchData = { data: data };

		if (place)
			searchData.location = place;

		/*
		if(price_min)
			searchData.priceMin = price_min;

		if(price_max)
			searchData.priceMax = price_max;
		*/

		// Update recent searches
		let searchVal = data;
		let updatedRecentSearches = [...recentSearches];
		if (!updatedRecentSearches.some(search => search.name === searchVal && search.place === (searchData?.location || null))) {
			updatedRecentSearches.unshift({ name: searchVal, place: searchData.location || null, min_price: searchData.priceMin || 0, max_price: searchData.priceMax || 0 });
			if (updatedRecentSearches.length > 5) {
				updatedRecentSearches = updatedRecentSearches.slice(0, 5);
			}
			await Preferences.set({ key: 'recentSearches', value: JSON.stringify(updatedRecentSearches) });
		}

		history.push("/search", searchData);
		/*
		setLocation(gew);
		setLocationResults([]);
		*/
	};

	const searchKeyDown = (ev) => {
		if (ev.key === 'Enter') {
			searchListClick(ev);
		}
	};

	const handleSearchFocus = () => {
		setShowRecentSearches(true);
	};

	const handleSearchBlur = () => {
		setTimeout(() => {
			setShowRecentSearches(false)
		}, 200);
	};

	function handleRefresh(event) {
		setTimeout(() => {
			FeaturedStore.update(s => {
				s.products = [];
				s.hasLoaded = false;
			});
			fetchFeatured();
			event.detail.complete();
		}, 1000);
	}

	const handleCategoryClick = async (cat_slug) => {

		// Save scroll position using the global manager
		await saveScrollBeforeNavigation();

		// Navigate to product detail
		history.push(`/category/${cat_slug}`);
	};

	const handleFooterLinkClick = async (link) => {
		await saveScrollBeforeNavigation();
		history.push(`/${link}`);
	}

	const handleGoToCategory = async () => {
		await saveScrollBeforeNavigation();
		history.push('/categories');
	};

	return (
		<IonPage id="home-page" className={styles.homePage}>
			<IonHeader>
				<IonToolbar>

					<IonButtons slot="start" className="ion-padding-start" color="drukre">
						<IonCardSubtitle className={styles.logo}></IonCardSubtitle>
					</IonButtons>
				</IonToolbar>
				<IonToolbar>
					<IonRow>
						<IonCol sizeLg="9" sizeMd="9" sizeSm="10" sizeXs="10" className="ion-align-self-center">
							{/*
							<IonItem>
								<IonIcon icon={locationOutline} color="drukre" />
								<IonInput label="Location" value={location} onIonChange={e => setLocation(e.target.value)}></IonInput>
							</IonItem>
							*/}
							<IonSearchbar
								onIonClear={(e) => setSearchResults([])} debounce={1000} label="Search"
								ref={searchInputRef} placeholder="Looking for ..." name="search"
								onIonInput={(ev) => handleSearchInput(ev)}
								onKeyDown={(ev) => searchKeyDown(ev)}
								onIonFocus={handleSearchFocus}
								onIonBlur={handleSearchBlur}
							></IonSearchbar>
							<IonList className="ion-padding-horizontal">
								{showRecentSearches && recentSearches.length > 0 && <IonCardSubtitle>Recent Searches</IonCardSubtitle>}
								{showRecentSearches && recentSearches.map((product, index) => (
									<IonButton fill="outline" color="medium" size="default"
										style={{ textTransform: 'none' }}
										key={index}
										onClick={(ev) => searchListClick(ev, product.name, product.place, product.min_price, product.max_price)}>
										<IonLabel>
											<IonText>{product?.name?.length > 10 ? product.name.substring(0, 10) + '..' : product.name}</IonText>
											{product.place && <small> in {product.place.length > 10 ? product.place.substring(0, 10) : product.place}</small>}
											{/*}
												<p>{prevFilterData.min_price ? 'Min $ '+prevFilterData.min_price : null}</p>
											*/}
										</IonLabel>
									</IonButton>
								))}
								{searchResults && searchResults.map((product, index) => {
									const trimmedProduct = product.length > 20 ? product.substring(0, 20) : product;
									return (
										<IonItem key={`prod_${index}`} index={index} onClick={(ev) => searchListClick(ev, trimmedProduct)}>{product.length > 20 ? trimmedProduct + ' ...' : trimmedProduct}</IonItem>
									);
								})}
							</IonList>
						</IonCol>
						<IonCol sizeSm="2" sizeXs="2" className="ion-hide-md-up">
							<IonButton size="small" color="drukre" onClick={(ev) => searchListClick(ev)}>
								<IonIcon icon={search} />
							</IonButton>
						</IonCol>
						<IonCol sizeLg="1" sizeMd="1" className="ion-hide-md-down">
							<IonButton color="drukre" onClick={(ev) => searchListClick(ev)}>
								<IonIcon icon={search} />
							</IonButton>
						</IonCol>
						<IonCol sizeLg="2" sizeMd="2" sizeSm="12" sizeXs="12" className="ion-align-self-center">
							<IonButtons className="ion-padding-end ion-float-end">
								<IonButton color="danger" onClick={() => handleFooterLinkClick("favourites")}>
									{favourites.length}
									<IonIcon icon={bookmarkOutline} />
								</IonButton>

								<IonButton color="drukre" onClick={() => handleFooterLinkClick("cart")}>
									{shopCart.length}
									<IonIcon ref={cartRef} className="animate__animated" icon={cartOutline} />
								</IonButton>
							</IonButtons>
						</IonCol>
					</IonRow>
				</IonToolbar>
			</IonHeader>

			<IonContent className="scroll-position-capture page-content">
				<IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
					<IonRefresherContent pullingIcon={refreshOutline} pullingText="Pull to refresh" refreshingSpinner="circles" refreshingText="Refreshing..."></IonRefresherContent>
				</IonRefresher>

				{/*
				<IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
					<IonRefresherContent refreshingSpinner="circles" color="drukre"></IonRefresherContent>
				</IonRefresher>
				{/*
				<IonToolbar>
					<IonReactRouter>
						<IonTabs>
							<IonRouterOutlet>
							<Route path="/favourites" exact>
								<FavouriteProducts />
							</Route>

							<Route path="/cart" exact>
								<CartProducts />
							</Route>
							</IonRouterOutlet>
							<IonTabBar slot="bottom" className={ styles.cartBadgeTabBar }>
								<IonTabButton tab="favourites" routerLink="/favourites">
									<IonIcon color="drukre" icon={heartOutline} />
									<IonBadge color="danger">{ favourites.length }</IonBadge>
								</IonTabButton>
								<IonTabButton tab="cart" href="/cart">
									<IonIcon color="drukre" icon={cartOutline} />
									<IonBadge color="danger">{ shopCart.length }</IonBadge>
								</IonTabButton>
							</IonTabBar>
							
						</IonTabs>
		 			</IonReactRouter>
				</IonToolbar>
			*/}
				<IonGrid>

					{suggestProducts && suggestProducts.length > 0 && (
						<>
							<IonRow>
								<IonCol>
									<IonCardSubtitle className='ion-padding-horizontal'>Based on your previous searches</IonCardSubtitle>
								</IonCol>
							</IonRow>
							<Swiper
								modules={[Navigation, Autoplay, Keyboard, Pagination, Scrollbar, Zoom]}
								spaceBetween={10} // Space between slides
								slidesPerView={2.2}
								// Responsive breakpoints
								breakpoints={{
									480: {
										slidesPerView: 2.5,
										spaceBetween: 20,
									},
									640: {
										slidesPerView: 4.5,
										spaceBetween: 20,
									},
									768: {
										slidesPerView: 4.5,
										spaceBetween: 20,
									},
									1024: {
										slidesPerView: 5.5,
										spaceBetween: 20,
									}
								}}
								loop={true} // Loop the slides
								autoplay={{
									delay: 3000, // Delay between slides
									disableOnInteraction: true, // Continue autoplay after interaction
								}}
								navigation // Optional: Add navigation arrows
								pagination={{ clickable: true }} // Optional: Add pagination dots
							>
								{suggestProducts.map((prod, index) => {
									let category = { slug: prod.category_name };
									return (
										<SwiperSlide key={`suggest_product_${index}`}>
											<ProductCard product={prod} index={index} cartRef={cartRef} category={category} />
										</SwiperSlide>
									);
								})}
							</Swiper>
						</>
					)}

					{!location.pathname.includes('/categories') && (
						<>
							<IonRow>
								<IonCol>
									<IonCardSubtitle className='ion-padding-horizontal'>Featured Products</IonCardSubtitle>
								</IonCol>
							</IonRow>
							<IonRow>
								{featuredProducts.map((prod, index) => {
									let category = { slug: prod.category_name };
									return (
										<IonCol sizeSm="6" sizeMd="3" key={`featured_product_${index}`}>
											<ProductCard key={`category_product_${index}`} product={prod} index={index} cartRef={cartRef} category={category} />
										</IonCol>
									);
								})}
							</IonRow>
							<IonRow>
								<IonCol>
									<IonButton className="ion-float-left" color="drukre" onClick={handleGoToCategory}>
										Go to Categories
									</IonButton>
								</IonCol>

								<IonCol>
									{hasMore && (
										<IonButton className="ion-float-right" color="warning" onClick={handleLoadMore} disabled={loading}>
											{loading ? 'Loading...' : 'Load More...'}
										</IonButton>
									)}
								</IonCol>
							</IonRow>
							{loading &&
								<IonRow>
									<IonCol>
										<IonProgressBar type="indeterminate" color="drukre"></IonProgressBar>
									</IonCol>
								</IonRow>
							}
						</>
					)}
					{location.pathname.includes('/categories') && (
						<>
							<IonRow>
								<IonCol>
									<IonCardSubtitle className='ion-padding-horizontal'>Categories</IonCardSubtitle>
								</IonCol>
							</IonRow>

							<IonRow>
								{products.map((category, index) => {

									return (
										<IonCol sizeXs="6" sizeSm="6" sizeMd="3" key={`category_list_${index}`} style={{ display: "flex", justifyContent: "center" }}>
											<IonCard
												onClick={() => handleCategoryClick(category.slug)}
												className={styles.categoryCard}
												style={{ height: '200px', display: 'flex', flexDirection: 'column' }}
											>
												<LazyImage
													src={`${process.env.REACT_APP_BASE_URL}/images/categories/${category.cover}`}
													placeholder="/assets/lazyimage.gif"
													alt="category cover"
													style={{ width: '100%', height: '100%' }}
												/>
												<IonCardContent color="drukre" className={styles.categoryCardContent}>
													<IonCardSubtitle>{category.name}</IonCardSubtitle>
												</IonCardContent>
											</IonCard>
										</IonCol>
									)
								})}
							</IonRow>
						</>
					)}
				</IonGrid>

				<IonFab horizontal="end" vertical="bottom" slot="fixed">
					<IonFabButton color="drukre" onClick={() => authValues.authenticated ? history.push("/my-products") : history.push("/login")}>
						<IonIcon icon={bagCheck}></IonIcon><sub>Sell</sub>
					</IonFabButton>
				</IonFab>
				<IonRow>
					<IonCol className="ion-text-center">
						<span onClick={() => handleFooterLinkClick("terms-and-conditions")}>
							<IonLabel>
								Terms and Conditions | Privacy Policy | &nbsp;
							</IonLabel>
						</span>
						<span onClick={() => handleFooterLinkClick("instructions")}>
							<IonLabel>
								Instructions | &nbsp;
							</IonLabel>
						</span>
						<Contact />
						<p style={{ fontSize: "small" }}>
							This application is protected by reCAPTCHA and the Google
							<a href="https://policies.google.com/privacy" target="_blank"> Privacy Policy</a> and
							<a href="https://policies.google.com/terms" target="_blank"> Terms of Service</a> apply.
						</p>
					</IonCol>
				</IonRow>
			</IonContent>
		</IonPage>
	);
};

export default Home;